import { useMemo } from 'react';
import appRoutes from '~/appRoutes';
import { type DashboardTab, useDashboardTabs } from '~/hooks/useDashboardTabs';
import { useFormatMessage } from '~/intl';

export function useDeliveryMonitoringTabs() {
  const formatMessage = useFormatMessage();

  const tabs = useMemo<DashboardTab[]>(
    () => [
      {
        icon: 'FileEditIcon',
        id: 'contracted-volumes',
        isDynamicRoute: true,
        label: formatMessage({ id: 'dashboard.shared.deliveryMonitoring.viewsExpectedVolumes' }, { count: 2 }),
        tooltip: formatMessage({ id: 'deliveryMonitoring.tab.expectedVolumes' }),
        route: appRoutes.DELIVERY_MONITORING_CONTRACTED_VOLUMES(),
      },
      {
        icon: 'BankIcon',
        id: 'delivered-volumes',
        isDynamicRoute: true,
        label: formatMessage({ id: 'dashboard.shared.deliveryMonitoring.viewsDeliveredVolumes' }, { count: 2 }),
        tooltip: formatMessage({ id: 'deliveryMonitoring.tab.deliveredVolumes' }),
        route: appRoutes.DELIVERY_MONITORING_DELIVERED_VOLUMES(),
      },
      {
        icon: 'LinksIcon',
        id: 'reconciled-volumes',
        isDynamicRoute: true,
        label: formatMessage({ id: 'grid.column.recognisedVolume' }, { count: 2 }),
        tooltip: formatMessage({ id: 'deliveryMonitoring.tab.recognisedVolumes' }),
        route: appRoutes.DELIVERY_MONITORING_RECONCILED_VOLUMES(),
      },
    ],
    [formatMessage],
  );

  return useDashboardTabs(tabs, {
    storageDefaultValue: 'contracted-volumes',
    storageKey: 'delivery-monitoring.tab',
  });
}
